import React, { useEffect, useMemo, useState } from "react";
import { Badge, Form, InputGroup } from "react-bootstrap";
import { oneKlicks } from "../../../SDK/oneclick";
import { getuserdata } from "../../../services/apiService";

// Assumes batches in seller_pharmacy_batches with expiry_date (YYYY-MM-DD) and quantity
const UpcomingExpiry = () => {
    const [rangeDays, setRangeDays] = useState(60);
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);

    const cutoff = useMemo(() => {
        const d = new Date();
        d.setDate(d.getDate() + Number(rangeDays || 0));
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
    }, [rangeDays]);

    const load = async () => {
        try {
            setLoading(true);
            const pharmacyId = await getuserdata("id");
            let res;
            try {
                // Prefer batches table if available
                res = await oneKlicks.read(
                    "",
                    "seller_pharmacy_batches",
                    { pharmacy_id: pharmacyId },
                    "expiry_date ASC",
                    { expiry_date: cutoff },
                    { page: 1, limit: 200 }
                );
            } catch (e) {
                res = null;
            }
            if (!(res?.success)) {
                try {
                    res = await oneKlicks.read(
                        "",
                        "seller_pharmacy_products",
                        { pharmacy_id: pharmacyId },
                        "product_name ASC",
                        { expiry_date: cutoff },
                        { page: 1, limit: 200 }
                    );
                } catch (e) {
                    res = null;
                }
            }
            const rows = res?.success ? res.data || [] : [];
            setList(rows);
        } catch (e) {
            setList([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { load(); }, [cutoff]);

    return (
        <div className="container-fluid py-3">
            <div className="card mb-5">
                <div className="card-body">
                    <div className="align-items-center justify-content-between mb-3">
                        <div className="d-flex align-items-center gap-2 mb-2">
                            <h5 className="mb-0 font-weight-bold mr-3" style={{ color: 'white' }}>Upcoming Expiry</h5>
                            <Badge bg="warning">Expiry Alerts</Badge>
                        </div>
                        <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                            <div className="d-flex align-items-center" style={{ gap: 8 }}>
                                <Form.Label className="mb-0" style={{ whiteSpace: 'nowrap' }}>
                                    Show items expiring within (days):
                                </Form.Label>
                                <InputGroup style={{ maxWidth: 120 }}>
                                    <Form.Control
                                        type="number"
                                        min="1"
                                        value={rangeDays}
                                        onChange={(e) => setRangeDays(Number(e.target.value))}
                                        size="sm"
                                    />
                                </InputGroup>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <div className="table-responsive">
                        <table hover size="sm" className="mb-0 align-middle">
                            <thead>
                                <tr>
                                    <th>Product / Batch</th>
                                    <th>Qty</th>
                                    <th>Expiry Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="3" className="text-center py-4">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </td>
                                    </tr>
                                ) : list.length === 0 ? (
                                    <tr>
                                        <td colSpan="3" className="text-center py-5">
                                            <h5 className="text-muted mb-2">No items nearing expiry</h5>
                                            <p className="text-muted mb-3">
                                                All products are within acceptable expiry range
                                            </p>
                                        </td>
                                    </tr>
                                ) : (
                                    list.map((r) => (
                                        <tr key={r.id}>
                                            <td data-label="Product / Batch" style={{ minWidth: 220 }}>
                                                <div style={{ fontWeight: '600', color: '#1890ff', marginBottom: '2px' }}>
                                                    {r.product_name || r.batch_name || "-"}
                                                </div>
                                            </td>
                                            <td data-label="Qty" style={{ fontWeight: '600', color: '#ff4d4f' }}>
                                                {r.quantity || 0}
                                            </td>
                                            <td data-label="Expiry Date">{r.expiry_date || "-"}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpcomingExpiry;


